import { gql } from '@biletiniz/apollo';

export const WALLET_HISTORY = gql`
  query walletHistory($pageSize: Int!, $skipPages: Int!) {
    walletHistory(filter: { pageSize: $pageSize, skipPages: $skipPages }) {
      status
      localizedStatus
      amount
      currency
      createdAt
      startDate
      expireDate
      type
      title
      description
    }
  }
`;
